// 应用平台-各类字典查询接口
import request from '@/utils/request'

// 资质宝通用字典查询
export const queryCommonDictionary = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/qualification/queryQualificationDictionary',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询证书类型字典
export const queryCertTypeDict = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/qualification/queryQualificationDictionaryByZslx',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询系统字典列表
export const querySystemDictList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_SYSTEM + '/api/sysDictionary/getDictList',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 递归查询字典（如：查询湖北省三级区划）
export const recursionDictData = params => {
	return request({
		url: process.env.VUE_APP_BASE_API + 'system/api/sysDictionary/recursionDictData',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

/**
 * 查询某个pid对应下属所有字典数据
 * @param params (parentId: '父级的pid',level: '表示查到第几层数据')
 * @returns {AxiosPromise}
 */
export function getDictFlattenList(params) {
	return request({
		url: process.env.VUE_APP_BASE_API + 'system/api/sysDictionary/recursionDictDataForList',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}
